import { Vue } from '~/addiesaas'

var GmapApi = null;

var _promiseLazy = _interopRequireDefault(require("gmap-vue/dist/utils/factories/promise-lazy"));

var _initializer = _interopRequireDefault(require("gmap-vue/dist/utils/manager/initializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const GmapVue = {
    install: function (Vue, options) {
     var finalOptions = _objectSpread({
        installComponents: true,
        autobindAllEvents: false
      }, options);

      GmapApi = new Vue({
        data: {
          gmapApi: null
        }
      });
      var defaultResizeBus = new Vue();

      var promiseLazyCreator = (0, _promiseLazy.default)(_initializer.default, GmapApi);
      var gmapApiPromiseLazy = promiseLazyCreator(finalOptions); // Instance properties

      Vue.mixin({
        created: function created() {
          this.$gmapDefaultResizeBus = defaultResizeBus;
          this.$gmapOptions = finalOptions;
          this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
        }
      }); // Static properties

      Vue.$gmapDefaultResizeBus = defaultResizeBus;
      Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    }
  };

Vue.use(GmapVue, {
    load: {
        key: window.addiesaas.lairdnd.google_maps_api_key,
        libraries: 'places',
    },
    installComponents: false
})
